export interface MediaSelectorDialogDataType {
    multiple: boolean;
}

export enum MediaSource {
    'UNSPLASH' = 'UNSPLASH',
    'SHUTTER_STOCK' = 'SHUTTER_STOCK',
    'DEVICE' = 'DEVICE',
}

export interface Image {
    width: number;
    height: number;
    url: string;
    blurHash?: string;
}

export interface Author {
    id: string;
    userName: string | null;
    name: string | null;
    twitterUserName: string | null;
    portFolioUrl: string | null;
    instagramUserName: string | null;
}

export interface Media {
    id?: string;
    businessId: string;
    uniqueId: string;
    blurHash: string | null;
    assets: Image[];
    author?: Author | null;
    media: MediaSource;
    description: string;
    altDescription: string;
    selected: boolean;
    file?: File;
}

export const FontFamilyList = [
    { text: 'Helvetica', subtext: 'Clean and widely used sans-serif' },
    { text: 'DM Sans', subtext: 'Modern and geometric typeface' },
    { text: 'Montessarat', subtext: 'Urban-inspired and stylish' },
    { text: 'Roboto', subtext: 'Default Android font, highly readable' },
    { text: 'Poppins', subtext: 'Rounded and geometric style' },
    { text: 'Lato', subtext: 'Warm and professional appearance' },
    { text: 'Nunito', subtext: 'Balanced and friendly sans-serif' },
    { text: 'Arial', subtext: 'Classic system font, very common' },
    { text: 'Open Sans', subtext: 'Versatile and legible on screens' },
    { text: 'Inter', subtext: 'Designed for digital interfaces' },
    { text: 'Mulish', subtext: 'Minimalist and modern design' },
    { text: 'Merriweather', subtext: 'Readable serif for long texts' },
    { text: 'Oswald', subtext: 'Condensed and impactful style' },
    { text: 'Source Sans Pro', subtext: 'Adobe’s clean and simple typeface' }
]
